import "bootstrap/dist/css/bootstrap.min.css";
import img1 from "../../../../assets/images/img (1).webp";
import img2 from "../../../../assets/images/img (10).webp";
import img3 from "../../../../assets/images/img (32).webp";
import img4 from "../../../../assets/images/about.png";
import "./Testimonial.css";

const Testimonials = () => {
  const testimonials = [
    {
      name: "John Doe",
      role: "Software Engineer",
      feedback:
        "This platform has completely transformed the way we analyze data. The actionable insights are incredible!",
      image: img1,
    },
    {
      name: "Jane Smith",
      role: "Data Scientist",
      feedback:
        "I love how intuitive the interface is. It helps me focus on the data rather than the tools!",
      image: img2,
    },
    {
      name: "Mike Johnson",
      role: "Business Analyst",
      feedback:
        "A must-have tool for anyone looking to optimize their processes and boost productivity!",
      image: img3,
    },
  ];

  return (
    <div id="testimonials" className="container my-5">
      <h2 className="text-center mb-5 font-weight-bold">
        What Our Clients Say
      </h2>
      <div className="row align-items-center">
        <div className="col-md-4 mb-4 mb-md-0">
          <img src={img4} alt="About" className="img-fluid rounded-lg" />
        </div>
        <div className="col-md-8 ">
          <div
            id="testimonialCarousel"
            className="carousel slide carousel-fade"
            data-bs-ride="carousel"
            data-bs-interval="3000"
            data-bs-pause="false"
          >
            <div className="carousel-inner  ">
              {testimonials.map((testimonial, index) => (
                <div
                  className={`carousel-item  ${index === 0 ? "active" : ""}`}
                  key={index}
                >
                  <div className="card text-center p-4 shadow-lg border-0 rounded-3 fs-6 text-dark background-dark  bg-gradient">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="rounded-circle mx-auto mb-4  rounded-3 testimonal-image"
                    />
                    <h5 className="mb-2 landing-text-white">{testimonial.name}</h5>
                    <p className="text-muted mb-3 landing-text-white ">{testimonial.role}</p>
                    <p className="text-muted landing-text-white">{testimonial.feedback}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="carousel-indicators justify-content-center ">
              {testimonials.map((_, index) => (
                <button
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide-to={index}
                  className={`carousel-indicator ${index === 0 ? "active" : ""
                    }`}
                  aria-current={index === 0 ? "true" : "false"}
                  aria-label={`Slide ${index + 1}`}
                  key={index}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;